import { render, staticRenderFns } from "./formCreateTransferRoute.vue?vue&type=template&id=6d2d479e&scoped=true"
import script from "./formCreateTransferRoute.vue?vue&type=script&lang=js"
export * from "./formCreateTransferRoute.vue?vue&type=script&lang=js"
import style0 from "./formCreateTransferRoute.vue?vue&type=style&index=0&id=6d2d479e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2d479e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d2d479e')) {
      api.createRecord('6d2d479e', component.options)
    } else {
      api.reload('6d2d479e', component.options)
    }
    module.hot.accept("./formCreateTransferRoute.vue?vue&type=template&id=6d2d479e&scoped=true", function () {
      api.rerender('6d2d479e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transfer/transferRoute/components/form/formCreateTransferRoute.vue"
export default component.exports